import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './styles/style.scss';

class Loading extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: this.props.active || false,
    };
  }

  // Prevents the animation from jumping
  shouldComponentUpdate(nextProps) {
    return nextProps.active !== this.state.active;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.active !== this.props.active) {
      if (!!this.props.active) {
        this.setState({ active: this.props.active });
      } else {
        // Prevents the animation from jumping
        setTimeout(() => {
          this.setState({ active: this.props.active });
        }, 300);
      }
    }
  }
  render() {
    const { active } = this.state;

    return (
      <div className={`loading-container ${active && 'is-loading'}`}>
        <div className="loader-wrapper">
          <div className="loader"></div>
        </div>
      </div>
    );
  }
}

Loading.propTypes = {
  active: PropTypes.bool,
};

export default Loading;
